var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('dash-tab',{key:tab.id,attrs:{"icon":tab.icon,"active":_vm.activeTab === tab.id,"data-test-tab-id":tab.id},nativeOn:{"click":function($event){return _vm.$emit('activate', tab.id)}}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }